import React, { PropTypes } from 'react';
import moment from 'moment';
import MsgAvatar from '../messaging-avatar';

const MessageWrapper = ({ children, avatarInfo, timestamp, isSender }) => {
  const time = moment(new Date(timestamp)).format('D MMM YYYY, H:mm');
  return (
    <div
        style={{
          display: 'flex',
          marginBottom: '24px',
          flexDirection: isSender ? 'row-reverse' : 'row',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ width: '40px', textAlign: isSender ? 'right' : 'left' }}>
          <MsgAvatar
            {...avatarInfo}
            tooltipPosition={isSender ? 'bottom-left' : 'bottom-right'}
          />
        </div>
        <div style={{ maxWidth: 'calc(88% - 44px)', textAlign: isSender ? 'right' : 'left' }}>
          <div
            className={isSender ? 'right-arrow-bubble' : 'left-arrow-bubble'}
          >
            <div
              style={{ width: '100%', minHeight: '40px', textAlign: 'left', display: 'inline-block', padding: '16px' }}
            >
              {children}
            </div>
          </div>
          {
            /*
             <EmailStatus
             commFeed={commFeed}
             />
             */
          }
          <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', marginBottom: '8px', textAlign: isSender ? 'right' : 'left' }}>
            {time}
          </div>
        </div>
      </div>
  );
};

MessageWrapper.propTypes = {
  children: PropTypes.node,
  avatarInfo: PropTypes.object,
  timestamp: PropTypes.string,
  isSender: PropTypes.bool,
};

export default MessageWrapper;



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/message-wrapper.jsx